module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"ctrl-psel\">\n    <div class=\"ctrl-psel-items\">\n\n    </div>\n    <div class=\"ctrl-psel-buttons\" style=\"margin-top: 10px;\">\n        <button class=\"ctrl-psel-select\">Выбрать</button>\n        <button class=\"ctrl-psel-remove\">Удалить</button>\n    </div>\n    <div class=\"overlay-loader\" style=\"display: none;\"></div>\n</div>")
  }
  return __output.join("");

}